import {messageBoxSuccess, messageBoxError} from '../components/message-box';

class RoomleMessageHandler {
  bindings() {
    window.addEventListener('message', (e) => {
      if (
        e.origin !== 'https://roomle-new.vallone.localhost:4040'
        && e.origin !== 'https://configurator.staging.vallone.de'
        && e.origin !== 'https://configurator.vallone.de'
      ) {
        return;
      } else {
        const language: string | null = document.documentElement.lang ?? '';

        let roomleUrl: string = '';
        if (process.env.NODE_ENV === 'development') {
          roomleUrl = 'https://roomle-new.vallone.localhost:4040';
        }
        else if (process.env.NODE_ENV === 'staging') {
          roomleUrl = 'https://configurator.staging.vallone.de';
        }
        else {
          roomleUrl = 'https://configurator.vallone.de';
        }

        if (e.data === 'redirect shop') {
          window.location.href = `${window.location.origin}${language === 'en-US' ? '/en/cart' : '/cart'}`;
        } else if (e.data === 'redirect wishlist') {
          window.location.href = `${window.location.origin}${language === 'en-US' ? '/en/wishlist' : '/merkliste'}`;
        } else if (e.data.action === 'redirect config') {
          window.location.href = e.data.url;
        } else if (e.data.action === 'success save wishlist') {
          messageBoxSuccess({
            contentDe: 'Erfolgreich zur Merkliste hinzugefügt',
            contentEn: 'Successfully added to wishlist',
          });

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'add_to_wishlist',
            ecommerce: {
              currency: e.data.currency === '€' ? 'EUR' : (e.data.currency === 'CHF' ? 'CHF' : 'USD'),
              value: e.data.price,
              content_type: 'product',
            }
          });

          const wishlistIconHeader: SVGElement | null = document.querySelector('.l-header__actions-button-wishlist .js-l-header__wishlist-icon');
          const wishlistIconHeaderInner: SVGTSpanElement | null | undefined = wishlistIconHeader?.querySelector('tspan');

          if (wishlistIconHeaderInner) {
            wishlistIconHeaderInner.innerHTML = String(Number(wishlistIconHeaderInner.innerHTML) + 1);
          }

          if (wishlistIconHeader) {
            wishlistIconHeader.style.display = 'block';
          }
        } else if (e.data === 'error save wishlist') {
          messageBoxError({
            contentDe: 'Konnte nicht zur Merkliste hinzugefügt werden',
            contentEn: 'Could not add to wishlist',
          });
        } else if (e.data.action === 'success add cart') {
          // messageBoxSuccess({
          //   contentDe: 'Erfolgreich zum Warenkorb hinzugefügt',
          //   contentEn: 'Successfully added to cart',
          // });

          const cartIconHeader: SVGElement | null = document.querySelector('.l-header__actions-button-cart .js-l-header__cart-icon');
          const cartIconHeaderInner: SVGTSpanElement | null | undefined = cartIconHeader?.querySelector('tspan');

          if (cartIconHeader) {
            cartIconHeader.style.display = 'block';
          }

          if (cartIconHeaderInner) {
            let sum = 0;
            let alreadyCounted: any[] = [];
            e.data.result.lineItems.forEach((lineItem: any) => {
              if (!lineItem.options?._configuratorId || lineItem.options?._configuratorMainItem === 'yes') {
                sum += lineItem.qty;
              }
              alreadyCounted.push(lineItem.options?._configuratorId);
            });
            cartIconHeaderInner.innerHTML = String(sum);
          }

          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { showCart: false },
          } as any));
        } else if (e.data.action === 'error add cart') {
          messageBoxError({
            contentDe: 'Konnte nicht zum Warenkorb hinzugefügt werden',
            contentEn: 'Could not add to cart',
          });
        } else if (e.data === 'error adding entry') {
          messageBoxError({
            contentDe: 'Konfiguration konnte nicht angelegt werden',
            contentEn: 'Could add configuration',
          });
        } else if (e.data === 'open request price popup') {
          const popup = document.querySelector('#roomle-popup-request-price');
          popup?.classList.add('m-popup--is-active');
          popup?.classList.add('request-price');
          document.body.classList.add('m-popup--is-visible');
          const popupButton = document.querySelector('#roomle-popup-request-price form button[type="submit"]') as HTMLButtonElement || null;
          if (popupButton) {
            popupButton.disabled = true;
          }
        } else if (e.data === 'open request expert popup') {
          const popup = document.querySelector('#roomle-popup-request-price');
          popup?.classList.add('m-popup--is-active');
          popup?.classList.add('request-expert');
          document.body.classList.add('m-popup--is-visible');
        } else if (e.data.action === 'add entry request price popup') {
          const popupButton = document.querySelector('#roomle-popup-request-price form button[type="submit"]') as HTMLButtonElement || null;

          if (popupButton) {
            popupButton.dataset.entryId = e.data.entryId;
            popupButton.dataset.currency = e.data.currency;
            popupButton.dataset.price = e.data.price;
            popupButton.disabled = false;
          }
        } else if (e.data === 'enable overflow') {
          const position = document.querySelector('.o-roomle-iframe')?.getBoundingClientRect().top;
          const header = document.querySelector('.l-header')?.clientHeight;
          window.scrollTo({
            top: (position ? position + window.scrollY : window.scrollY) - (header ? header : 0),
            left: 0,
            behavior: 'smooth',
          });
          document.body.classList.remove('roomle-is-open');
        } else if (e.data === 'just disable overflow') {
          document.body.classList.add('roomle-is-open');

          const position = document.querySelector('.o-roomle-iframe')?.getBoundingClientRect().top;
          const header = document.querySelector('.l-header')?.clientHeight;
          window.scrollTo({
            top: (position ? position + window.scrollY : window.scrollY) - (header ? header : 0),
            left: 0,
            behavior: 'smooth',
          });

          setTimeout(() => {
            const position = document.querySelector('.o-roomle-iframe')?.getBoundingClientRect().top;
            const header = document.querySelector('.l-header')?.clientHeight;
            window.scrollTo({
              top: (position ? position + window.scrollY : window.scrollY) - (header ? header : 0),
              left: 0,
              behavior: 'smooth',
            });
          }, 550);
        } else if (e.data === 'disable overflow') {
          document.body.classList.add('roomle-is-open');

          const position = document.querySelector('.o-roomle-iframe')?.getBoundingClientRect().top;
          window.scrollTo({
            top: position ? position + window.scrollY : window.scrollY,
            left: 0,
            behavior: 'smooth',
          });

          setTimeout(() => {
            const position = document.querySelector('.o-roomle-iframe')?.getBoundingClientRect().top;
            window.scrollTo({
              top: position ? position + window.scrollY : window.scrollY,
              left: 0,
              behavior: 'smooth',
            });
          }, 550);
        } else if (e.data === 'open id modal') {
          const trigger = document.getElementById('open-config-modal');
          trigger?.click();
        } else if (e.data === 'open sales email modal') {
          const trigger = document.getElementById('open-config-sales-email');
          trigger?.click();
        } else if (e.data.action === 'add entry sales email modal') {
          const popupButton = document.querySelector('#form-popup form[name="open-config-sales-email"] button[type="submit"]') as HTMLButtonElement || null;

          if (popupButton) {
            popupButton.dataset.entryId = e.data.entryId;
            popupButton.classList.remove('is-disabled');
          }
        } else if (e.data === 'get parent url') {
          (document.querySelector('.o-roomle-iframe iframe') as HTMLIFrameElement | null)?.contentWindow?.postMessage({
            action: 'parent url',
            url: `${window.location.origin}${window.location.pathname}`,
            // TODO: replace this url later for live
          }, roomleUrl);
        } else if (e.data === 'scroll down') {
          window.scrollTo({
            top: window.scrollY + window.innerHeight / 1.5,
            left: 0,
            behavior: 'smooth',
          });
        }
      }
    });
  }

  cache() {

  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default RoomleMessageHandler;
